var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, forwardRef, useImperativeHandle, useEffect, } from 'react';
import { IconButton, InputBase, Tooltip, } from '@mui/material';
import { AlertCircle, HelpCircle } from '@diamond-design/icons';
import styles from './InputField.module.scss';
import { lendingClubPalette } from '../theme/palette';
import FormHelperText from '../formHelperText';
import InputLabel from '../inputLabel';
import Button from '../button/Button';
export const LabelPositions = ['left', 'right'];
export const InputField = (props, ref) => {
    const { label, labelPosition = 'left', iconLeft: IconLeft, labelStyle, iconRight: IconRight, error, errors, helperText, helperTextStyle, disabled, inputStyle, style, value, tooltip, tooltipPosition = 'top', tooltipStyle, onIconRightClick, onFocus, onBlur, validate: validateCustom, buttonProps, withButton } = props, rest = __rest(props, ["label", "labelPosition", "iconLeft", "labelStyle", "iconRight", "error", "errors", "helperText", "helperTextStyle", "disabled", "inputStyle", "style", "value", "tooltip", "tooltipPosition", "tooltipStyle", "onIconRightClick", "onFocus", "onBlur", "validate", "buttonProps", "withButton"]);
    const [isError, setError] = useState(false);
    const [isFocus, setFocus] = useState(false);
    const inputRef = useRef(null);
    useEffect(() => {
        setError(!!error || !!errors);
    }, [error, errors]);
    const validate = () => __awaiter(void 0, void 0, void 0, function* () {
        if (validateCustom)
            return validateCustom();
        if (inputRef && inputRef.current)
            return inputRef.current.checkValidity();
        return null;
    });
    useImperativeHandle(ref, () => {
        const inputElement = (inputRef.current || {});
        inputElement.validate = validate;
        inputElement.props = props;
        return inputElement;
    });
    const Icon = (newProps = {}) => {
        if (IconRight)
            return React.createElement(IconRight, Object.assign({}, newProps));
        if (isError)
            return React.createElement(AlertCircle, Object.assign({}, newProps));
        if (tooltip)
            return React.createElement(HelpCircle, Object.assign({}, newProps));
        return null;
    };
    const handleFocus = (event) => {
        onFocus && onFocus(event);
        setFocus(true);
    };
    const handleBlur = (event) => {
        onBlur && onBlur(event);
        setFocus(false);
    };
    const handleIconRightMouseDown = (event) => {
        if (onIconRightClick) {
            event.preventDefault();
            event.stopPropagation();
            onIconRightClick(event);
        }
    };
    const shouldShowHelperText = error || errors || helperText;
    return (React.createElement("div", { "aria-label": "input-container", className: [
            styles.container,
            style,
            withButton ? styles.inputWithButton : '',
        ].join(' '), style: {
            pointerEvents: disabled && !withButton ? 'none' : 'auto',
        } },
        label && (React.createElement(InputLabel, { style: Object.assign({ textAlign: labelPosition, marginLeft: -5 }, labelStyle) }, label)),
        React.createElement("div", { className: styles.button_container },
            React.createElement("div", { "aria-label": "input-row", className: [
                    styles.input,
                    disabled ? styles.disabled : '',
                    isError ? styles.error : '',
                    isFocus ? styles.focused : '',
                    isError && isFocus ? styles.errorFocused : '',
                    inputStyle,
                ].join(' ') },
                React.createElement(InputBase, Object.assign({ disabled: disabled, className: styles.inputText, value: value, onFocus: handleFocus, onBlur: handleBlur, onInvalid: () => setError(true), onInput: () => {
                        setError(false);
                    }, startAdornment: !!IconLeft && (React.createElement(IconLeft, { color: lendingClubPalette.gray[500], role: "icon", className: styles.iconLeft, width: 16, height: 16 })), endAdornment: !!Icon() && (React.createElement(Tooltip, { title: tooltip, className: tooltipStyle, placement: tooltipPosition },
                        React.createElement(IconButton, { onMouseDown: handleIconRightMouseDown },
                            React.createElement(Icon, { color: isError
                                    ? lendingClubPalette.error[500]
                                    : lendingClubPalette.gray[400], width: 16, height: 16 })))) }, rest, { inputRef: inputRef }))),
            withButton && (React.createElement(Button, Object.assign({}, buttonProps, { variant: "tertiary", className: styles.suffixEl })))),
        shouldShowHelperText ? (React.createElement(FormHelperText, { error: error, errors: errors, helperText: helperText, style: helperTextStyle })) : null));
};
export default forwardRef(InputField);
